import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Icon from "components/Icon";
import PropTypes from "prop-types";
import React from "react";

export default function Banner({ message, icon }) {
  return (
    <React.Fragment>
      <Paper elevation={0} sx={{ pt: 2, px: 2, pb: 1 }}>
        <Grid
          container
          spacing={0}
          wrap="nowrap"
          sx={{
            alignItems: "center",
          }}
        >
          <Grid>
            <Avatar sx={{ backgroundColor: "primary.main" }}>
              <Icon icon={icon} />
            </Avatar>
          </Grid>
          <Grid>
            <Typography
              sx={(theme) => ({
                color: theme.palette.gray.main,
                [theme.breakpoints.up("sm")]: { pl: 3 },
                [theme.breakpoints.down("sm")]: { pl: 2 },
              })}
            >
              {message}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Divider />
    </React.Fragment>
  );
}

Banner.propTypes = {
  icon: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
};
